import react from "react";
import Request from "../../../../../api/Requests";

const postSponsorVenue = (params) => {
    
    return Request('sponsors/setup-sponsor-venue', 'POST', params, true);
}

export default {
    postSponsorVenue,
}